/**
 * Created by - Ashlekh on 12-08-2024
 * Reason - To have Blog Detailed section
 */

import { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import style from "./newsDetail.module.css";
import config from "../../Api/config";
import { getNewsDetailsApi } from "../../Api/services";
import parse from "html-react-parser";
import { GlobalContext } from "../../context/Context";
import NavigationPath from "../../components/NavigationPath/NavigationPath";

const NewsDetailed = () => {
  const [newsDetails, setNewsDetails] = useState([]);
  const [filteredNewsDetails, setFilteredNewsDetails] = useState([]);
  const location = useLocation();
  const newsId = location.state;
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);

  // Added by - Ashlekh on 12-08-2024
  // Reason - This useEffect will executes when page loads
  useEffect(() => {
    /**
     * Added by - Jhamman lal sahu on 28-09-2024
     * Reason - Scroll to top when refresh
     */
    // window.scrollTo(0, 0);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    /**
     * End of addition by - Jhamman lal sahu on 28-09-2024
     * Reason - Scroll to top when refresh
     */

    /**
     * Added by - Jhamman lal sahu on 22-09-2024
     * Reason - To add paths to navigation path variable
     */
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "News", path: "/news" },
      { name: "News Details", path: "/news_detailed" },
    ]);
    /**
     * End of addition by - Jhamman lal sahu on 22-09-2024
     * Reason - To add paths to navigation path variable
     */
  }, []);
  // End of code - Ashlekh on 12-08-2024
  // Reason - This useEffect will executes when page loads

  useEffect(() => {
    if (newsId != null && newsId != "") {
      getNewsDetails();
    }
  }, [newsId]);

  useEffect(() => {
    if (newsDetails?.news != null) {
      const filteredBlog = newsDetails.news.filter((news) => news.id == newsId);
      setFilteredNewsDetails(filteredBlog);
    }
  }, [newsDetails, newsId]);

  const getNewsDetails = async () => {
    const response = await getNewsDetailsApi();
    setNewsDetails(response);
  };
  return (
    <div className={`${style.pageContainer}`}>
      {/* Added by - Jhamman lal sahu on 22-08-2024
            Reason - To add path in UI */}
      <NavigationPath navigationPathArray={navigationPath} />
      {/* Added by - Jhamman lal sahu on 22-08-2024
            Reason - To add path in UI */}

      <div className={`${style.content}`}>
        {filteredNewsDetails?.map((news) => (
          <div key={news.id} className={`${style.blogDetailsContainer}`}>
            <div className={`${style.blogTitle}`}>{news.title}</div>
            <div className={`${style.imageContainer}`}>
              <img
                src={config.baseURL + news?.image}
                alt=""
                className={`${style.image}`}
              />
            </div>
            <div className={`${style.description}`}>
              {" "}
              {parse(news?.description)}{" "}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default NewsDetailed;
